type ContentType = {
	[type: string]: string;
};

export const contentType: ContentType = {
	'text/plain': 'txt',
	'text/html': 'html',
	'application/json': 'json',
	'image/jpeg': 'jpg',
	'image/png': 'png',
	'audio/mpeg': 'mp3',
	'video/mp4': 'mp4',
	'application/pdf': 'pdf',
	'application/msword': 'doc',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
	'application/vnd.ms-excel': 'xls',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
	'application/vnd.ms-powerpoint': 'ppt',
	'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
};

export function getExtension(type: string): string | null {
	const extension = contentType[type];
	return extension || null;
}
